import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import type { CheckoutSession } from '@/shared/domain'
import type {
  CreateCheckoutSession,
  CreateCheckoutSessionParams,
} from '@/modules/auth/use-cases'

export class EdgeCreateCheckoutSessionRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: CreateCheckoutSession = async (params) => {
    const body = buildBody(params)
    const request: HttpRequest<typeof body> = {
      url: '/subscriptions/checkout-session',
      body,
    }
    return this.httpClient.post<typeof body, CheckoutSession>(request)
  }
}

function buildBody(params: CreateCheckoutSessionParams) {
  const body: {
    orgType: string
    subscriptionTier: string
    successUrl: string
    cancelUrl: string
    currency: string
    orgName?: string
    orgState?: string
    promotionCodeId?: string
  } = {
    orgType: params.orgType,
    subscriptionTier: params.subscriptionTier,
    successUrl: params.successUrl,
    cancelUrl: params.cancelUrl,
    currency: params.currency,
  }
  if (params.orgName !== undefined) body.orgName = params.orgName
  if (params.orgState !== undefined) body.orgState = params.orgState
  if (params.promotionCodeId !== undefined) body.promotionCodeId = params.promotionCodeId
  return body
}
